import axioInstance from "@/libs/axios";
import { WithdrawalPolicyResponse } from "@/types/withdrawal";

const fetchWithdrawalPolicy = async (): Promise<WithdrawalPolicyResponse> => {
  const result =
    await axioInstance.get<WithdrawalPolicyResponse>("/policy/withdrawal");
  return result?.data;
};

export default fetchWithdrawalPolicy;
